<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Frequently Asked Questions
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!--Information of Cash and Payment at PSI-->
  <ion-item lines="full">
    <ion-icon name="cash" slot="start"></ion-icon>
    <h4 class="ion-text-uppercase">Cash / Payment</h4>
  </ion-item>
  <ion-grid fixed>
    <ion-row>
      <ion-col>
        <h5>PSI Badge</h5>
        <p>
          Using cash (Swiss bank notes only) loaded on PSI badge during regular working hours & week-ends.
        </p>
      </ion-col>
      <ion-col>
        <h5>Cash <small>(CHF/EUR)</small></h5>
        <p>
          Using cash (banks notes & coins) at the cafeteria during regular working hours.
        </p>
        <p>
          Using cash (bank notes & coins) at the foodtrucks.
        </p>

      </ion-col>
      <ion-col>
        <h5>Credit Card</h5>
        <p>
          Can be used at the PSI restaurants OASE (PSI East) and Time Out (PSI West) and at the guesthouse reception.
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
  <p>
    <strong>No cash machine on site therefore users need to organize in advance!</strong>
  </p>
  <!--Information of User Office-->
  <ion-item lines="full">
    <ion-icon name="people" slot="start"></ion-icon>
    <h4>User Office</h4>
  </ion-item>
  <p>
    The Paul Scherrer Institute operates five major user laboratories: a third generation X-ray synchrotron source
    (SLS), a X-ray free electron laser facility (SwissFEL), the only continuous spallation neutron source worldwide
    (SINQ), the worlds most powerful continuous-beam μSR facility (SμS) and a meson factory for fundamental nuclear
    and
    elementary particle physics (LTP). In fact, PSI is one of the very few places worldwide to offer the three major
    probes for condensed matter research (photons, neutrons and muons) on one campus.
  </p>
  <p>
    The PSI User Office is a central PSI installation to serve the users from all the large scale user laboratories of
    PSI. In case of any question before, during or after your stay at PSI please don't hesitate to contact us.
  </p>
  <!--Information of Digital User Office (DUO)-->
  <ion-item lines="full">
    <ion-icon name="desktop-outline" slot="start"></ion-icon>
    <h4>Digital User Office <small>(DUO)</small></h4>
  </ion-item>
  <p>
    The central tool to organize the user operation at PSI is called the <strong>D</strong>igital
    <strong>U</strong>ser
    <strong>O</strong>ffice DUO.
    DUO is a Web application to submit proposals, experimental reports, publications, to request for PSI badges or
    dosimeters etc.
  </p>
  <!--Link to the Digital User Office Login-->
  <a title="Link to DUO" href="https://duo.psi.ch/duo/" target="_blank" rel="noopener noreferrer">
    <ion-button expand="block" color="light">
      DUO Login
    </ion-button>
  </a>
  <!--Information how to rent a bike at psi-->
  <ion-item lines="full">
    <ion-icon name="bicycle" slot="start"></ion-icon>
    <h4>Rent Bikes</h4>
  </ion-item>
  <p>
    The PSI user office holds a pool of bicycles (and helmets) for users of the PSI facilities. A bike will make your
    stay at PSI more comfortable and you will be able to easily reach the neighbouring villages like Villigen,
    Würenlingen or even Brugg to do some shopping. If you wish to borrow a bike (no costs, just a deposit of CHF 50,-)
    please contact the user office (call 4666) upon arrival or send an
    <a title="Mail to user office" href="#" (click)="openEmail('useroffice@psi.ch')">email to us</a>.
    Please note that the maximum duration for renting a bicycle is 2 weeks.
  </p>
  <!--Information about the food at psi-->
  <ion-item lines="full">
    <ion-icon name="restaurant" slot="start"></ion-icon>
    <h4>Food</h4>
  </ion-item>
  <p>
    The PSI restaurant "OASE" is open from Mon-Fri over lunch and between 5-8 p.m. in the evenings. In addition there
    is the Cafeteria "Time Out" on the campus of PSI West next to the SLS main entrance. The "Time Out" offers fresh
    food and sandwich lunches during and food from vending machines out of office hours. Please note that the PSI
    restaurants partly do accept credit cards. In addition you can pay cash (CHF or EUR) or you may upload your PSI
    badge with Swiss Francs.<br>
    In addition a Pizza service and several food trucks are available between Friday night and Sunday. Please visit
    <a title="Link to food and catering at PSI" href="https://www.psi.ch/useroffice/food-and-catering" target="_blank"
      rel="noopener noreferrer">this page</a>
    for more information.
  </p>
  <!--Information about the psi guesthouse-->
  <ion-item lines="full">
    <ion-icon name="bed" slot="start"></ion-icon>
    <h4>Guesthouse</h4>
  </ion-item>
  <p>
    The Paul Scherrer Institut operates a Guest House to offer a local and practical accommodation for its visitors,
    guests and users on site. The Guest House is located in the Western part of the PSI campus and offers 57 single and
    8 double rooms. A few more single rooms are located in the building of the PSI restaurant OASE.
  </p>
  <!--Information about the wifi connections at psi-->
  <ion-item lines="full">
    <ion-icon name="wifi" slot="start"></ion-icon>
    <h4>WiFi Connection</h4>
  </ion-item>
  <p>
    PSI provides several WiFi (WLAN) networks accessible for our users from abroad:
  </p>
  <ul>
    <li><strong>eduroam</strong>: for our users with access to eduroam networks (non-PSI staff only)</li>
    <li><strong>guest</strong>: for our users without eduroam account</li>
  </ul>
  <p>
    Please note: the guest network is restricted to a couple of important webpages only. For unlimited access please
    connect to the guest network and open a <strong>VPN connection</strong> to your home institution. If that is not
    possible
    <a title="Link to order of an wlan account at PSI" href="https://www.psi.ch/computing/order-wlan-accounts"
      target="_blank" rel="noopener noreferrer">please
      apply for a temporary guest account!</a>
  </p>
  <p>
    More information together with a map of the WiFi hotspots at PSI is
    <a title="Link to WLAN at PSI" href="https://www.psi.ch/computing/wlan" target="_blank"
      rel="noopener noreferrer">available here</a>.
  </p>

</ion-content>
